export default class {
	static convert(timeInSeconds) {
		if (timeInSeconds > 3600) {
			let hours = (timeInSeconds / 3600);
			return (hours == 1 ? hours + " hour" : hours + " hours");
		}
		if (timeInSeconds > 60) {
			let minutes = (timeInSeconds / 60);
			return (minutes == 1 ? minutes + " minute" : minutes + " minutes");
		}
		if (timeInSeconds > 0) {
			return (timeInSeconds == 1 ? timeInSeconds + " second" : timeInSeconds + " seconds");
		}
		return "0";
	}
}



// WEBPACK FOOTER //
// ./src/utils/secondsToTimePeriod.js